var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6702 6.95003C21.0302 4.78003 19.2202 2.97003 17.0502 2.33003C15.4002 1.85003 14.2602 1.89003 13.4702 2.48003C12.5202 3.19003 12.4102 4.47003 12.4102 5.38003V7.87003C12.4102 10.33 13.5302 11.58 15.7302 11.58H18.6002C19.5002 11.58 20.7902 11.47 21.5002 10.52C22.1102 9.74003 22.1602 8.60003 21.6702 6.95003Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9094 13.36C18.6494 13.06 18.2694 12.89 17.8794 12.89H14.2994C12.5394 12.89 11.1094 11.46 11.1094 9.70003V6.12003C11.1094 5.73003 10.9394 5.35003 10.6394 5.09003C10.3494 4.83003 9.94941 4.71003 9.56941 4.76003C7.21941 5.06003 5.05941 6.35003 3.64941 8.29003C2.22941 10.24 1.70941 12.62 2.15941 15C2.80941 18.44 5.55941 21.19 9.00941 21.84C9.55941 21.95 10.1094 22 10.6594 22C12.4694 22 14.2194 21.44 15.7094 20.35C17.6494 18.94 18.9394 16.78 19.2394 14.43C19.2894 14.04 19.1694 13.65 18.9094 13.36Z",
    fill: "#050505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graphIcon.315c9574390e39caee1425563fb0f03a.svg";
export { ForwardRef as ReactComponent };